export class ProcedureSelectionDialogModel {
  datasource: Procedure[];
}

interface Form {
  id: string;
  dFormID: string;
  name: string;
  filledBy: string;
  isOpenByDefault: boolean;
  isAddByDefault: boolean;
  formOrder: number;
}

interface Procedure {
  id: string;
  code: string;
  description: string;
  name: string;
  forms: Form[];
  deletedForms: Form[];
  speciality: string; // enumMedicalSpeciality
  partOfAppointmentGroup: boolean;
  appointmentAddByDefault: boolean;
  partOfVisitGroup: boolean;
  visitAddByDefault: boolean;
  enumProcedureActionCategoryID: string;
}
